import { render, staticRenderFns } from "./GamutCompressButton.vue?vue&type=template&id=a1fdadca&"
import script from "./GamutCompressButton.vue?vue&type=script&lang=js&"
export * from "./GamutCompressButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports